import { defineStore } from "pinia"
import { RouteLocationNormalized, RouteMeta } from "vue-router"
import { getTitle, Head } from "@/router/helpers"

export interface State extends RouteMeta {
  head: Head
}

export const useMetaStore = defineStore("meta", {
  state: (): State => ({
    head: {}
  }),
  getters: {
    title: (state) => getTitle(state.head?.title)
  },
  actions: {
    fromRoute(route: RouteLocationNormalized) {
      this.$state = { head: {}, ...route.meta }
    }
  }
})
